import {ValidationEmployeeContract} from "components/management-contract/create-contract/create-contract-import/ValidationEmployeeContract";
import {useEffect, useState} from "react";
import {useFetch} from "../../../../services/useFetch";
import {API_CONTRACT_IMPORT} from "../../../../services/apiContractImport";

export const ValidationEmployeeContractContainer = ({payload, onChangeStep, setViewData}) => {
    const [percentage, setPercentage] = useState(0)
    const {fetching: importValidation, data: response, isLoading} = useFetch(API_CONTRACT_IMPORT.IMPORT_VALIDATION)

    useEffect(() => {
        if (percentage === 10) {
            importValidation(payload, null, {'Content-Type': 'multipart/form-data'})
                .then().catch(() => {
                onChangeStep(1)
            })
        }
    }, [percentage])

    useEffect(() => {
        let timeout = null
        if (percentage <= 80) {
            timeout = setTimeout(() => {
                setPercentage(percentage + 10)
            }, 1000)
        } else if (!isLoading && response?.data) {
            timeout = setTimeout(() => {
                if (percentage === 100) {
                    setViewData(response?.data)
                    onChangeStep(3)
                } else {
                    setPercentage(percentage + 10)
                }
            }, 1000)
        }

        return () => {
            clearTimeout(timeout)
        }
    }, [percentage, isLoading])

    return (
        <ValidationEmployeeContract percentage={percentage}/>
    )
}
